import { render, staticRenderFns } from "./VesselBuildersIndex.vue?vue&type=template&id=69852dca&"
import script from "./VesselBuildersIndex.vue?vue&type=script&lang=js&"
export * from "./VesselBuildersIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports